import Vue from 'vue';

const success = (response, context) => {
  context.loading = false;
  if(response.data.data.airlockWithFrictionView.viewPayload.frictionData.phoneNumbers) {
    context.phoneNumberId = response.data.data.airlockWithFrictionView.viewPayload.frictionData.phoneNumbers[0].id;
    context.airLockUID = response.data.data.airlockWithFrictionView.id;
    context.frictionDataReceived = true;
  }else{
    context.airLockUID = response.data.data.airlockWithFrictionView.id;
    context.frictionDataReceived = true;
  }
};

const failed = (error, context) => {
  if (error && error.response && error.response.status == 400) {
    context.activeStep = 1;
    context.loading = false;
    if (error.response.data.msg && error.response.data.msg == 'duplicated') {
      toastr.error(context.$t('account.settings.user_platforms_section.duplicated_airbnb_account'));
    }
  } else if (error && error.data && error.data.status == 'error' && error.status == 403) {
    context.activeStep = 1;
    context.loading = false;
    toastr.error(context.$t('login.wrong_credentials'));
  } else {
    context.activeStep = 1;
    context.loading = false;
    toastr.error(context.$t('rentals.detail.modals.something_went_wrong'));
  }
};

export default (context) => {
  const data = {
    airlock: context.airlockData.airlock,
    friction: context.airlockData.friction,
    randomDeviceId: context.registration ? context.airbnbAccount.randomDeviceId : context.randomDeviceId,
  };
  Vue.$http.post('/get-friction-view', data).then((response) => {
    console.log(response);
    if (response && response.status === 200) {
      success(response, context);
    }
  })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/account/getFrictionView.js